import { DateTime } from 'luxon';
import { BaseModel } from './base';

export interface GalleryComment extends BaseModel {
    franchiseId: number | null;
    comment: string,
    stars: number,
    created: string;
    author: string;
    general: boolean | null;
}


export const newGalleryComment: GalleryComment = {
    id: 0,
    franchiseId: 0,
    comment: '',
    stars: 5,
    created: DateTime.now().toISO(),
    author: '',
    general: null
};
